import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/Home";

import Banking from "./Components/Banking";

// Dummy pages (you can change content later)
const About = () => <div className="p-10 text-2xl">About Page</div>;
const Services = () => <div className="p-10 text-2xl">Services Page</div>;
const Contact = () => <div className="p-10 text-2xl">Contact Page</div>;

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/banking" element={<Banking />} />
      </Routes>
    </Router>
  );
};

export default App;
